<script setup lang="ts">
import { computed } from 'vue';

import type { AppCircleCheckboxTheme } from './AppCircleCheckbox.model';

interface CheckedProps {
  theme: AppCircleCheckboxTheme;
}

const props = defineProps<CheckedProps>();

const backgroundColor = computed(() =>
  props.theme === 'light' ? '#413A5C' : '#fff'
);

const checkColor = computed(() =>
  props.theme === 'light' ? '#fff' : '#413A5C'
);
</script>

<template>
  <svg
    v-if="props.theme === 'radio'"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
  >
    <circle cx="11" cy="11" r="10" stroke="#1A1726" stroke-width="2" />
    <circle cx="11" cy="11" r="6" fill="#1A1726" />
  </svg>
  <svg
    v-else
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" :fill="backgroundColor" />
    <g clip-path="url(#clip0_8781_9820)">
      <path
        d="M9.99677 14.7793L7.21677 11.9993L6.27344 12.9427L9.99677 16.666L17.9968 8.66599L17.0534 7.72266L9.99677 14.7793Z"
        :fill="checkColor"
        :stroke="checkColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_8781_9820">
        <rect
          width="16"
          height="16"
          :fill="backgroundColor"
          transform="translate(4 4)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
